import { motion } from "framer-motion";
import { Star, ArrowRight } from "lucide-react";
import { ClientLogoStrip } from "@/components/ClientLogoStrip";

const GOOGLE_REVIEW_URL = "https://g.page/r/Cb5fjWKUDdkKECE/review";

export function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[92vh] flex flex-col items-center text-center px-4 pt-28 pb-10 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.08),transparent_60%)] pointer-events-none" />
      <img src="/assets/hero-bg.jpg" alt="" aria-hidden
        data-testid="hero-bg-image"
        className="absolute inset-0 w-full h-full object-cover object-[center_55%] opacity-90 pointer-events-none hidden md:block" />
      <img src="/assets/hero-bg-mobile.jpg" alt="" aria-hidden
        data-testid="hero-bg-image-mobile"
        className="absolute inset-0 w-full h-full object-cover object-[center_62%] opacity-90 pointer-events-none md:hidden" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#090A0F]/80 via-[#090A0F]/35 to-[#090A0F] pointer-events-none" />
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center">
        <div className="relative w-fit">
          <motion.img
            src="/assets/logo-wide.png"
            alt="M&M Productions logo"
            data-testid="hero-logo"
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="w-80 sm:w-[26rem] lg:w-[36rem]"
          />
          <img src="/assets/logo-wide.png" alt="" aria-hidden data-testid="hero-logo-energy" className="energy-sweep" />
        </div>
        <motion.p
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.8 }}
          data-testid="hero-tagline"
          className="font-heading text-base sm:text-xl lg:text-2xl font-bold tracking-tight -mt-2 text-white [text-shadow:0_2px_14px_rgba(0,0,0,0.9)]"
        >
          &ldquo;Turning Ideas Into Reality&rdquo;
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.75, duration: 0.8 }}
          className="mt-2 flex flex-col items-center gap-3"
        >
          <div className="flex items-center gap-1" data-testid="google-stars" aria-label="Five star Google reviews">
            {[...Array(5)].map((_, i) => (
              <Star key={i} data-testid={`google-star-${i + 1}`} className="h-4 w-4 text-[#D4AF37]" fill="#D4AF37" strokeWidth={0} />
            ))}
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-3" data-testid="hero-cta-group">
            <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer" data-testid="google-review-btn"
              className="btn-fill notched-sm inline-flex items-center gap-2 border border-amber-400/40 bg-transparent px-5 py-2 text-xs font-semibold text-amber-300 hover:text-black hover:shadow-[0_0_25px_rgba(212,175,55,0.35)] transition-[color,box-shadow] duration-300">
              Leave a Google Review
              <ArrowRight className="h-4 w-4" />
            </a>
            <a href="#contact" data-testid="get-in-touch-btn"
              className="btn-fill notched-sm inline-flex items-center gap-2 border border-amber-400/40 bg-transparent px-5 py-2 text-xs font-semibold text-amber-300 hover:text-black hover:shadow-[0_0_25px_rgba(212,175,55,0.35)] transition-[color,box-shadow] duration-300">
              Get in Touch
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </motion.div>
      </div>
      <ClientLogoStrip />
    </section>
  );
}
